import * as SeparatorPrimitive from '@radix-ui/react-separator';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';
import { separatorVariants } from '@/shared/constants/ui-variants';
import { cn } from '@/shared/lib/utils';

export interface SeparatorProps
  extends
    Omit<
      React.ComponentPropsWithoutRef<typeof SeparatorPrimitive.Root>,
      'orientation'
    >,
    Omit<VariantProps<typeof separatorVariants>, 'style'> {
  readonly orientation?: 'horizontal' | 'vertical';
  readonly separatorStyle?: VariantProps<typeof separatorVariants>['style'];
}

const Separator = React.forwardRef<
  React.ComponentRef<typeof SeparatorPrimitive.Root>,
  SeparatorProps
>(
  (
    {
      className,
      orientation = 'horizontal',
      decorative = true,
      thickness,
      spacing,
      separatorStyle,
      ...props
    },
    ref
  ) => (
    <SeparatorPrimitive.Root
      ref={ref}
      decorative={decorative}
      orientation={orientation}
      className={cn(
        separatorVariants({
          orientation,
          thickness,
          spacing,
          style: separatorStyle,
        }),
        className
      )}
      {...props}
    />
  )
);
Separator.displayName = SeparatorPrimitive.Root.displayName;

export { Separator };
export {
  SeparatorThickness,
  SeparatorSpacing,
  SeparatorStyle,
} from '@/shared/types/separator.types';
